// Opens the print dialog once the printable template has rendered and its
// images have decoded. Printing on a bare setTimeout raced the logo image
// load, so the first print after a fresh page load could miss the logo.
export function printPrintableContent(): void {
  setTimeout(async () => {
    const images = Array.from(
      document.querySelectorAll<HTMLImageElement>('.printable-screen img'),
    );
    await Promise.all(images.map((img) => img.decode().catch(() => undefined)));
    window.print();
  });
}
